module.exports = __webpack_public_path__ + "static/media/rent_zima.de293c06.png";